<template>
  <transition name="wtf"
              @enter="enter"
              @leave="leave"
              @enter-cancelled="enterCancelled"
              @leave-cancelled="leaveCancelled"
              @after-leave="complete"
              @after-enter="complete">
    <slot />
  </transition>
</template>


<script>
import { TweenMax, TimelineMax } from 'gsap';

export default {
  name: 'TransitionWtf',
  css: false,

  methods: {
    enter: function (el, done) {
      if (this.tl) {
        this.tl.play();
      } else {
        this.tl = new TimelineMax({
          onComplete: done,
          onReverseComplete: done,
        });
        const animationElements = [...el.querySelectorAll('.js-transition--stagger')].reverse();
        this.tl.add(TweenMax.staggerFromTo(animationElements, 0.15, { opacity: 0 }, { opacity: 1 }, 0.05));
      }
    },
    enterCancelled: function (el) {
    },
    leave: function (el, done) {
      this.tl.eventCallback('onReverseComplete', done);
      this.tl.reverse();
    },
    leaveCancelled: function (el) {
    },
    complete: function () {
      this.$emit('complete');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/transitions/TransitionWtf.vue